import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { UserSearchPreferences } from '@vestiaire/api-sdk-angular/model/userSearchPreferences';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import * as fromCatalog from '@app/+catalog/store/reducers';
import { TrackPersonalization } from '@app/+catalog/store';

@Component({
  selector: 'vc-modal-personalization',
  templateUrl: './modal-personalization.component.html',
  styleUrls: ['./modal-personalization.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ModalPersonalizationComponent implements OnInit {
  config = {
    env: environment.envName
  };

  public isEditView = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserSearchPreferences | null,
    public dialogRef: MatDialogRef<ModalPersonalizationComponent>,
    private store: Store<IAppState>
  ) {}

  ngOnInit(): void {
    this.store.select(fromCatalog.getPersonalization).subscribe(
      res => {
        this.isEditView = res?.preferences?.filter !== '';
      },
      error => {
        console.error(error);
      }
    );
  }

  closeModal() {
    this.dialogRef.close();
  }

  onSave(event) {
    if (this.isEditView) {
      this.editCompleted();
    } else {
      this.onboardingCompleted(event);
    }
  }

  onboardingCompleted(event: { universe: number[] }) {
    this.store.dispatch(
      new TrackPersonalization({
        event: 'preferences_created',
        eventAction: 'onboarding process',
        eventLabel: 'personalization enabled',
        perso_universe: event?.universe?.reduce((acc, curr) => acc + +curr, 0) // 1: Women, 2: Men, 3: Women & Men
      })
    );
  }

  editCompleted() {
    this.store.dispatch(
      new TrackPersonalization({
        event: 'edit_preferences_confirmation',
        eventAction: 'edit perso',
        eventLabel: 'save'
      })
    );
  }
}
